module.exports = __webpack_public_path__ + "static/media/btn_primaryschool_04_onlinegrooming.ec7782af.png";